export const GoogleProdApiDefaults = {
    googleSlidesApi: {
        clientId: "6191919743-sufgg6qjqns4vckucr5hh3kivkdn6sla.apps.googleusercontent.com",
        oAuthRedirectUrl: "https://maker.sermoncentral.com/googleauth/",
        scope: "https://www.googleapis.com/auth/presentations",
        apiUrl: "https://slides.googleapis.com/v1/presentations",
        presentationUrl: "https://docs.google.com/presentation/d/{id}/edit",
        cdnUrl: "https://i.cdn-sc.com",
        defaultBackgroundImageUrls: {
            "wide": "https://i.cdn-sc.com/defaultSlideImages/Image1-16x9.png",
            "standard": "https://i.cdn-sc.com/defaultSlideImages/Image1-16x9.png"
        }
    },
}

const dev = {
    mainSiteUrl: 'https://dev.sermoncentral.com',
    paymentsUrl: 'https://dev-payments.sermoncentral.com',
    solr: {
        url: 'https://stage-solr.sermoncentral.com/solr',
        auth: {
            type: 'none',
            user: '',
            password: ''
        }
    }
};

const prod = {
    mainSiteUrl: 'https://www.sermoncentral.com',
    paymentsUrl: 'https://payments.sermoncentral.com',
    solr: {
        url: 'https://solr.sermoncentral.com/solr',
        auth: {
            type: 'basic',
            user: 'builder',
            password: 'Reach0ut'
        }
    }
};

const config = process.env.REACT_APP_ENV === 'development' ? dev : prod;

export default config